import { useContext, useState } from "react";
import {
  Card,
  Form,
  Col,
  Row,
  Table,
  Container,
  Button,
} from "react-bootstrap";
import TFamilyService from "services/tfamily.service";
import Pagination from "components/Util/Pagination";
import { getLastWeekDate } from "helpers/dateHelper";
import AppContext from "store/AppContext";
import moment from "moment";
import Loader from "react-spinners/BarLoader";
import CollectiveMembers from "components/Collective/CollectiveMembers";

export default function TFamilyLog(props) {
  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState("");
  const [filter, setFilter] = useState({
    groupId: "",
    startDate: getLastWeekDate(),
  });
  const [data, setData] = useState({
    list: [],
    pagination: {
      offset: 0,
      limit: 10,
      count: 0,
    },
  });
  const [migrationData, setMigrationData] = useState({
    collective: [],
    migration: [],
    tfamily: [],
    consent: [],
  });

  const getLog = async (offset = 0, limit = 10) => {
    try {
      const res = await TFamilyService.familyLog(
        filter.groupId,
        filter.startDate,
        offset,
        limit,
      );
      setData(() => ({
        list: res.data.items,
        pagination: {
          offset: offset,
          limit: limit,
          count: res.data.total,
        },
      }));
    } catch (err) {
      appContext.notify("tr", "danger", err.message);
      console.log(err, "get log error");
    }
  };

  const getMigrationLog = async () => {
    try {
      setLoading(true);
      const res = await TFamilyService.getMigrationLog(mobile);
      setMigrationData(res.data);
    } catch (err) {
      console.log(err);
      appContext.notify("tr", "danger", err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Row>
        <Col md="9" lg="9">
          <CollectiveMembers
            collective={props.collective}
            showAlert={props.showAlert}
            notify={props.notify}
            refreshCollective={props.refreshCollective}
          ></CollectiveMembers>
        </Col>
        <Col md="9">
          <Card>
            <Card.Header>
              <Card.Title as="h4"> Лог</Card.Title>
            </Card.Header>
            <Card.Body>
              <Col>
                <Form>
                  <Row>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Group Id</Form.Label>
                        <Form.Control
                          value={filter.groupId}
                          onChange={(e) => {
                            setFilter((prev) => ({
                              ...prev,
                              groupId: e.target.value,
                            }));
                          }}
                          type="text"
                          placeholder="groupId"
                          required
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group as={Col} controlId="startDate">
                        <Form.Label>Эхлэх огноо</Form.Label>
                        <Form.Control
                          type="date"
                          format="yyyy-mm-dd"
                          value={filter.startDate}
                          onChange={(e) => {
                            setFilter((prev) => ({
                              ...prev,
                              startDate: e.target.value,
                            }));
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="mt-4">
                      <Button
                        variant="primary"
                        className="btn btn-sm"
                        size="md"
                        onClick={() => {
                          getLog(0, 10);
                        }}
                      >
                        Хайх
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Table>
                <thead>
                  <tr>
                    <th>Group Id</th>
                    <th>Action </th>
                    <th>Source</th>
                    <th>Actor Mobile</th>
                    <th>Target Mobile</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.list.map((log) => (
                    <tr>
                      <td>{log.groupId}</td>
                      <td>{log.action}</td>
                      <td>{log.source}</td>
                      <td>{log.actorPhone}</td>
                      <td>{log.targetPhone}</td>
                      <td>
                        {moment(log.createdAt).format("YYYY-MM-DD HH:MM")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
            <Pagination pagination={data.pagination} onChange={getLog} />
          </Card>
        </Col>
        <Col md="9">
          <Card>
            {loading ? <Loader /> : null}
            <Card.Header>
              <Card.Title>Migration</Card.Title>
            </Card.Header>
            <Col>
              <Form>
                <Row>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        value={mobile}
                        onChange={(e) => {
                          setMobile(e.target.value);
                        }}
                        type="text"
                        placeholder="Phone Number"
                        required
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col className="mt-4">
                    <Button
                      variant="primary"
                      className="btn btn-sm"
                      size="md"
                      onClick={() => {
                        console.log("clicked");
                        getMigrationLog();
                      }}
                    >
                      Хайх
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Table>
              <thead>
                <tr>
                  <th>Mobile</th>
                  <th>Balance</th>
                  <th>Group Id</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Joined At</th>
                </tr>
              </thead>
              <tbody>
                {migrationData.migration?.map((row) => (
                  <tr>
                    <td>{row?.mobile}</td>
                    <td>{row?.balance}</td>
                    <td>{row?.groupId}</td>
                    <td>{row?.role}</td>
                    <td>{row?.status}</td>
                    <td>{row?.joinedAt}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
          <Card>
            <Card.Header>
              <Card.Title>T Family</Card.Title>
            </Card.Header>
            <Table>
              <thead>
                <tr>
                  <th>Mobile</th>
                  <th>Balance</th>
                  <th>Family Id</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {migrationData.tfamily?.map((row) => (
                  <tr>
                    <td>{row?.mobile}</td>
                    <td>{row?.balance}</td>
                    <td>{row?.family_id}</td>
                    <td>{row?.role}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
          <Card>
            <Card.Header>
              <Card.Title>Collective</Card.Title>
            </Card.Header>
            <Table>
              <thead>
                <tr>
                  <th>Mobile</th>
                  <th>Balance</th>
                  <th>Family Id</th>
                  <th>isAdmin</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {migrationData.collective?.map((row) => (
                  <tr>
                    <td>{row?.mobile}</td>
                    <td>{row?.balance}</td>
                    <td>{row?.groupId}</td>
                    <td>{row?.isAdmin ? "admin" : "member"}</td>
                    <td>{row?.date}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
          <Card>
            <Card.Header>
              <Card.Title>Consent</Card.Title>
            </Card.Header>
            <Table>
              <thead>
                <tr>
                  <th>Mobile</th>
                  <th>Family no</th>
                  <th>Segment</th>
                  <th>Family Id</th>
                  <th>Sms</th>
                  <th>Sms Date</th>
                </tr>
              </thead>
              <tbody>
                {migrationData.consent?.map((row) => (
                  <tr>
                    <td>{row?.phone}</td>
                    <td>{row?.familyNo}</td>
                    <td>{row?.segment}</td>
                    <td>{row?.familyId}</td>
                    <td>{row?.sms}</td>
                    <td>{row?.smsDate}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    </>
  );
}
